export default __webpack_public_path__ + "static/media/brandpool.2a072c79.jpg";